import { MutableRefObject, RefObject, useEffect } from "react";

/**
 * Observes when a given element changes size and runs callback when element does
 * @param elementToObserve - Element to observe
 * @param callback - Function that is ran
 */
export const useResizeObserver = (elementToObserve: MutableRefObject<Element> | RefObject<Element>, callback: (elements: ResizeObserverEntry[]) => void) => {
    useEffect(() => {
        let resizeObserver: ResizeObserver;
        if (elementToObserve?.current != null) {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(elementToObserve.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);
};
